import { SwipeableDrawer, IconButton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { AssistantHeader } from '../../pages/plans/advanced/ui/co-pilot-sidebar/ui/assistant-header';
import {
  ChatBubbleStream,
} from '../../pages/plans/shared/chat-assistant';

// ─── Types ────────────────────────────────────────────────────────────────────

interface CopilotDrawerProps {
  open: boolean;
  onClose: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const CopilotDrawer = ({ open, onClose }: CopilotDrawerProps) => {
  const location = useLocation();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => {/* noop */}}
      onClose={onClose}
      disableSwipeToOpen
      sx={{zIndex: 1400}}
      PaperProps={{ sx: { height: '100dvh', borderRadius: 0, display: 'flex', flexDirection: 'column' } }}
    >
      <DrawerHeader>
        <AssistantHeader />
        <CloseBtn onClick={onClose} size="small">
          <X size={18} />
        </CloseBtn>
      </DrawerHeader>

      <Stack sx={{ flex: 1, minHeight: 0 }}>
        <ChatBubbleStream
          key={location.pathname}
          initialMessage="Hi! I'm your A.I. Medicare Copilot."
          placeholder="Ask a question..."
          suggestedLabel="Suggested questions:"
          fillHeight
        />
      </Stack>
    </SwipeableDrawer>
  );
};

// ─── Styled ───────────────────────────────────────────────────────────────────

const DrawerHeader = styled('div')({
  position: 'relative',
  flexShrink: 0,
});

const CloseBtn = styled(IconButton)({
  position: 'absolute',
  top: 8,
  right: 12,
  color: '#6b7280',
});
